@if (showBackButton$ | async) {
  <ds-results-back-button [back]="back"></ds-results-back-button>
}
<div class="d-flex flex-row">
  <ds-item-page-title-field class="me-auto" [item]="object">
  </ds-item-page-title-field>
  <ds-dso-edit-menu></ds-dso-edit-menu>
</div>
<div class="row">
  <div class="col-xs-12 col-md-4">
    <ds-metadata-field-wrapper [hideIfNoTextContent]="false">
      <ds-thumbnail [thumbnail]="object?.thumbnail | async"
        [defaultImage]="'assets/images/person-placeholder.svg'"
        [alt]="'thumbnail.person.alt'"
        [placeholder]="'thumbnail.person.placeholder'">
      </ds-thumbnail>
    </ds-metadata-field-wrapper>
 <!--   <ds-generic-item-page-field [item]="object"
      [fields]="['person.email']"
      [label]="'person.page.email'">
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
      [fields]="['person.birthDate']"
      [label]="'person.page.birthdate'">
    </ds-generic-item-page-field>
      -->
  </div>

  <div class="col-xs-12 col-md-7">
<!--<ds-related-items
      [parentItem]="object"
      [relationType]="'isProjectOfPerson'"
      [label]="'item.page.projects' | translate">
    </ds-related-items>
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isOrgUnitOfPerson'"
      [label]="'item.page.org-units' | translate">
    </ds-related-items>
-->
    <ds-generic-item-page-field [item]="object"
      [fields]="['person.jobTitle']"
      [label]="'person.page.jobtitle'">
      
    </ds-generic-item-page-field>
    <ds-generic-item-page-field [item]="object"
    [fields]="['person.affiliation.name']"
    [label]="'person.page.affiliation'"
    [enableMarkdown]="true">
  </ds-generic-item-page-field>
  <ds-generic-item-page-field [item]="object"
  [fields]="['organization.url']"
  [label]="'person.page.organizationurl'"
  [enableMarkdown]="true">
</ds-generic-item-page-field>
<ds-generic-item-page-field [item]="object"
[fields]="['person.identifier.rid']"
[label]="'person.identifier.rid'"
[enableMarkdown]="true">
</ds-generic-item-page-field>
<ds-generic-item-page-field [item]="object"
[fields]="['person.identifier.orcid']"
[label]="'person.identifier.orcid'"
[enableMarkdown]="true">
</ds-generic-item-page-field>

  <!-- <ds-generic-item-page-field [item]="object"
      [fields]="['dc.title']"
      [label]="'person.page.name'">
  </ds-generic-item-page-field> --> 
    <div>
      <a class="btn btn-outline-primary" [routerLink]="[itemPageRoute + '/full']" role="button" tabindex="0">
        {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
  <div class="mt-5 w-100 px-0">
    <ds-tabbed-related-entities-search  [item]="object"
                                        [relationTypes]="[{
                                          label: 'isAuthorOfPublication',
                                          filter: 'isAuthorOfPublication',
                                          configuration: 'default-relationships'
                                        }]">
    </ds-tabbed-related-entities-search>
  </div>
</div>
